import { Hero as HygraphHeroProps, Maybe as HygraphMaybe } from '@/lib/types';

import { HeroContextProvider } from '@/context/hero-context';
import SectionsRenderer from '@/hygraph/renderers/sections.renderer';

const HeroRenderer = ({
  hero,
}: {
  hero: HygraphMaybe<HygraphHeroProps> | undefined;
}) => {
  if (!hero) {
    return <></>;
  }

  return (
    <HeroContextProvider isHero={true}>
      <div className='relative'>
        {hero.section && <SectionsRenderer sections={[hero.section]} />}
      </div>
    </HeroContextProvider>
  );
};

export default HeroRenderer;
